var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.showCancellations
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-card",
                    [
                      _c("gg-card-header", [_vm._v(" My Cancellations ")]),
                      _c(
                        "gg-card-text",
                        [
                          _c(
                            "gg-loading",
                            {
                              attrs: {
                                loading: _vm.loading,
                                type: "table"
                              }
                            },
                            [
                              _c("v-data-table", {
                                attrs: {
                                  headers: _vm.headers,
                                  items: _vm.cancellations,
                                  loading: _vm.loading,
                                  "footer-props": {
                                    itemsPerPageOptions: _vm.paginationBilling
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item.id",
                                      fn: function fn(_ref) {
                                        var item = _ref.item
                                        return [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: "/cancellations/".concat(
                                                  item.id
                                                )
                                              }
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v("#" + _vm._s(item.id))
                                              ])
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "item.product",
                                      fn: function fn(_ref2) {
                                        var item = _ref2.item
                                        return [
                                          _vm._v(
                                            " " + _vm._s(item.product) + " "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            " " + _vm._s(item.domain) + " "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "item.status",
                                      fn: function fn(_ref3) {
                                        var item = _ref3.item
                                        return [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "pb-1",
                                              attrs: {
                                                small: "",
                                                color: _vm.statusColor(
                                                  item.status
                                                )
                                              }
                                            },
                                            [_vm._v("mdi-circle")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.statusNameFormatter(
                                                  item.status
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "item.actions",
                                      fn: function fn(_ref4) {
                                        var item = _ref4.item
                                        return [
                                          _c(
                                            "gg-btn",
                                            {
                                              attrs: {
                                                to: "/cancellations/".concat(
                                                  item.id
                                                )
                                              }
                                            },
                                            [_vm._v(" View Details ")]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2392550638
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }